import { useState, useEffect, useRef, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import Alert from '@mui/material/Alert'
import FlexColumn from '../../shared/components/layouts/FlexColumn'
import Flex from '../../shared/components/layouts/Flex'
import { useAuthentication } from '../../contexts/AuthenticationContext'

const POLL_INTERVAL_MS = 3000

const LoginLocationConfirmation = ({ confirmationToken, message, onResult }) => {
  const { checkLoginConfirmation } = useAuthentication()
  const [error, setError] = useState(null)
  const intervalRef = useRef(null)
  const isMountedRef = useRef(true)

  const poll = useCallback(() => {
    checkLoginConfirmation(confirmationToken)
      .then((result) => {
        if (!isMountedRef.current) return
        if (result.type === 'token') {
          clearInterval(intervalRef.current)
          onResult(result)
        }
      })
      .catch((err) => {
        if (!isMountedRef.current) return
        clearInterval(intervalRef.current)
        setError(err.message)
      })
  }, [confirmationToken, checkLoginConfirmation, onResult])

  useEffect(() => {
    isMountedRef.current = true
    intervalRef.current = setInterval(poll, POLL_INTERVAL_MS)

    return () => {
      isMountedRef.current = false
      clearInterval(intervalRef.current)
    }
  }, [poll])

  return (
    <FlexColumn gap={2} alignItems="center">
      <Typography variant="body1">
        {message || <FormattedMessage id="login.locationConfirmation.message" />}
      </Typography>

      {error && (
        <Alert severity="error">{error}</Alert>
      )}

      {!error && (
        <Flex justifyContent="center" fullWidth>
          <CircularProgress />
        </Flex>
      )}

      <Typography variant="body2">
        <FormattedMessage id="login.locationConfirmation.hint" />
      </Typography>
    </FlexColumn>
  )
}

export default LoginLocationConfirmation
